/**
 * Get size of Bytes2 (always 2)
 *
 * @param {import('./Bytes2Type.js').Bytes2Type} _bytes - Bytes2
 * @returns {2} Size (always 2)
 *
 * @example
 * ```typescript
 * const size = Bytes2.size(bytes); // 2
 * ```
 */
export function size(_bytes) {
	return 2;
}
